module.exports = __webpack_public_path__ + "img/1.04f754ec.svg";